
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.md?watch=parent';
    export const demoIndex = {
  ids: ["bar-demo-common","bar-demo-markdown","bar-demo-group","bar-demo-stack"],
  getter: () => import(/* webpackChunkName: "meta__Bar" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.md?type=demo')
};